const PolicyHero = () => {
  return (
    <section className="relative py-32 overflow-hidden bg-[#F8FBF6]">
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-10 left-10 w-32 h-32 rounded-full bg-[#89B56B]"></div>
        <div className="absolute bottom-10 right-20 w-48 h-48 rounded-full bg-[#5DAA68]"></div>
        <div className="absolute top-1/2 left-1/3 w-24 h-24 rounded-full bg-[#3F6844]"></div>
      </div>

      <div className="relative z-10 max-w-5xl mx-auto px-6 text-center pt-8">
        <p className="text-[#5DAA68] text-xs font-semibold tracking-[0.3em] uppercase mb-4 font-['Inter']">
          Policy
        </p>
        <h2 className="text-3xl md:text-4xl font-bold text-[#89B56B] font-['Noto_Sans_JP'] mb-4">
          経営指針
        </h2>
        <p className="text-sm text-gray-500 max-w-lg mx-auto leading-relaxed">
          株式会社MSKの経営方針・社訓をご紹介いたします
        </p>
      </div>
    </section>
  );
};

export default PolicyHero;
